import { Animated } from "react-native";

export const animateBounce = (anim: Animated.Value) => {
  Animated.sequence([
    Animated.timing(anim, {
      toValue: 1.3,
      duration: 150,
      useNativeDriver: true,
    }),
    Animated.timing(anim, {
      toValue: 1,
      duration: 150,
      useNativeDriver: true,
    }),
  ]).start();
};

export const animatePulse = (anim: Animated.Value) => {
  Animated.loop(
    Animated.sequence([
      Animated.timing(anim, {
        toValue: 1,
        duration: 600,
        useNativeDriver: true,
      }),
      Animated.timing(anim, {
        toValue: 0.3,
        duration: 600,
        useNativeDriver: true,
      }),
    ]),
  ).start();
};
